import Stack from "@mui/material/Stack";

/** Progress bars wired to `.project-card-root:hover` selectors on the carousel card. */
export function SiliconPlanOverlay() {
  return (
    <Stack spacing={1.5} sx={{ maxWidth: 160 }}>
      <Stack
        className="silicon-plan-bar-top sil-plan-bar-top-c"
        sx={{
          width: "75px",
          height: "8px",
          bgcolor: "#3333331A",
          borderRadius: 5,
          transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Stack
          className="silicon-plan-bar-top-fill sil-plan-bar-top-f"
          sx={{
            width: "50%",
            height: "100%",
            bgcolor: "#A29BD3",
            borderRadius: 5,
            transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        />
      </Stack>
      <Stack
        className="silicon-plan-bar-bottom sil-plan-bar-bot-c"
        sx={{
          width: "120px",
          height: "8px",
          bgcolor: "#3333331A",
          borderRadius: 5,
          transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Stack
          className="silicon-plan-bar-bottom-fill sil-plan-bar-bot-f"
          sx={{
            width: "70%",
            height: "100%",
            bgcolor: "#A29BD3",
            borderRadius: 5,
            transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        />
      </Stack>
    </Stack>
  );
}
